export const colors = {
  primaryColor : "#03c7f9",
  secondaryColor : "#080808",
  textWithWhiteBg : "#181818",
  textWithPrimaryColorBg : "#181818",
  linearGradient :
"linear-gradient(108.01deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.6) 41.4%, rgba(3, 199, 249, 0.491765) 82.8%, rgba(3, 199, 249, 0.24) 124.19%)",
darkColor:"#04a7d1"
}